import { render } from "./InstructorAccessStatus.vue?vue&type=template&id=62fe5b3f&scoped=true"
import script from "./InstructorAccessStatus.vue?vue&type=script&lang=js"
export * from "./InstructorAccessStatus.vue?vue&type=script&lang=js"

import "./InstructorAccessStatus.vue?vue&type=style&index=0&id=62fe5b3f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62fe5b3f"]])

export default __exports__